<template>
  <div></div>
</template>

<script>
import Clappr from 'clappr';
import ContainerPlugin from './clappr-responsive-container-plugin.js';

export default {
  name: "videoplayer",
  props: ["url", "autoplay", "position"],
  data () {
    return {
      player: "",
      clip_end: undefined
    }
  },
  watch: {
    "position": function(new_position) {
      if (new_position > -1) {
        this.player.seek(new_position);
      }
    }
  },
  methods: {
    play_clip(start, stop) {
      this.player.seek(start);
      this.player.play();
      this.clip_end = stop;
    },
    play () {
      this.player.play();
    },
    pause () {
      this.player.pause();
    },
    position_duration (position, duration) {
      if (typeof(this.clip_end) != "undefined") {
        if (position > this.clip_end) {
          this.player.pause();
          this.clip_end = undefined;
          this.$emit("playing-clip", false);
        }
      }
    },
    toggle() {
      if( this.player.isPlaying() ) this.pause()
      else this.play()
    }
  },
  mounted: function() {
    var self = this;
    var autoplay = this.autoplay;
    if (typeof(autoplay) == "undefined") {
      autoplay = false;
    }

    this.player = new Clappr.Player({
      source: this.url,
      parent: this.$el,
      plugins: [
        ContainerPlugin
      ],
      maxBufferLength: 3,
      disableKeyboardShortcuts: true,
      autoPlay: true,
      loop: true,
      hideMediaControl: false,
      playback: {
        playInline: true,
      }
    });

    var initializing = true;
    this.player.on(Clappr.Events.PLAYER_PLAY, function(event) {
      if (initializing == true) {
        self.player.getPlugin("responsive_container").resize();
        self.$emit("loaded");
        self.player.pause();
        initializing = false;
      }
    });

    this.player.on(Clappr.Events.PLAYER_TIMEUPDATE, function(event) {
      self.position_duration(event.current, event.total);
      self.$emit("position-duration", {position: event.current, duration: event.total});
    });

    this.$nextTick(() => {
      self.player.getPlugin("responsive_container").resize();
    });

  },
  beforeDestroy: function() {
    this.player.destroy();
  }
}

</script>

<style scoped>
</style>
